export default "__VITE_ASSET__C$vDRNlH__"